export default {
  title: {
    addJob: 'Post New Job',
    editJob: 'Edit Job',
    addTemplate: 'Add Job Template',
    editTemplate: 'Edit Job Template',
    step: {
      BASE_INFO: 'Basic Job Information',
      ADDITIONAL_INFO: 'Additional Information',
      DESCRIPTION_INFO: 'Job Description',
      APPLICATION_CONFIG: 'Application Configuration',
      OPEN_QUESTION: 'Applicant Questionnaire / Screening',
      POST_CHANNEL: 'Job Posting Distribution',
      STATUS_HISTORY: 'Job Status / History',
      PERSONALITY_CALIBRATION: 'Personality Fit Benchmark',
      AI_COMPARISON_CRITERION: 'Candidate AI Comparison Table',
      AI_INTERVIEW_ROOM: 'AI Interview Room',
      JOB_FIT_CONDITION: 'Candidate AI Fit Criteria'
    },
    jobSettingsTitle: 'Job Setting Logic',
    automationSettingsTitle: 'Automation Logic',
    customContent: {
      text: 'Text',
      silder: 'Slide Show',
      picture: 'Picture Board',
      video: 'Video'
    }
  },
  label: {
    stepName: {
      BASE_INFO: 'Basic Job Information',
      ADDITIONAL_INFO: 'Additional Information',
      DESCRIPTION_INFO: 'Job Description',
      APPLICATION_CONFIG: 'Application Configuration',
      OPEN_QUESTION: 'Applicant Questionnaire / Screening',
      POST_CHANNEL: 'Job Posting Distribution',
      STATUS_HISTORY: 'Job Status / History',
      PERSONALITY_CALIBRATION: 'Personality Fit Benchmark',
      AI_COMPARISON_CRITERION: 'Candidate AI Comparison Table',
      AI_INTERVIEW_ROOM: 'AI Interview Room',
      JOB_FIT_CONDITION: 'Candidate AI Fit Criteria'
    },
    isEditableTemplate: 'Job Property',
    jobTemplate: 'Job Template',
    company: 'Company',
    storeFront: 'Door',
    jobCreator: 'Job Creator',
    jobMember: 'Team Member(s)',
    jobCnName: 'Chinese Job Title',
    jobEnName: 'English Job Title',
    jobVisibility: 'Job Visibility',
    atsId: '3RD Party ATS ID',
    tag: 'Tag',
    visibleOnlyMember: 'Visible To Creator And Team Member Only',
    requireExperience: 'Job Type',
    roleType: 'Role Type',
    location: 'GEO Location(s)',
    experience: 'Experience Required',
    salary: 'Compensation',
    workTime: 'Work Time',
    industryType: 'Job Industry',
    jobCloseDate: 'Job Close Date',
    attractiveWords: 'Attractive Words',
    scaleWithValue: 'Response Scale {scale}',
    noScale: 'N/A',
    showCompanyCustomDetailPage: 'Company Level JD Customization',
    showVideoGuide: 'Video Guide',
    videoNavigationEn: 'Video Library (EN)',
    videoNavigationCn: 'Video Library (CN)',
    videoSourceLibrary: 'Media Library (Video)',
    pcCnDetailHeader: 'PC Chinese JD Header',
    mobileCnDetailHeader: 'Mobile Chinese JD Header',
    pcCnDetailFooter: 'PC Chinese JD Footer',
    mobileCnDetailFooter: 'Mobile Chinese JD Footer',
    pcEnDetailHeader: 'PC English JD Header',
    mobileEnDetailHeader: 'Mobile English JD Header',
    pcEnDetailFooter: 'PC English JD Footer',
    mobileEnDetailFooter: 'Mobile English JD Footer',
    cnDetailHead: 'Chinese JD Header',
    cnDetail: 'Chinese Description',
    cnDetailFoot: 'Chinese JD Footer',
    enDetailHead: 'English JD Header',
    enDetail: 'English Description',
    enDetailFoot: 'English JD Footer',
    reminderEmail: 'Email To Receive Notice',
    resumeEmail: 'Email To Receive Resume',
    show: 'Show',
    notShow: 'Hidden',
    locationSelector: {
      city: 'City',
      region: 'District',
      cbd: 'CBD',
      address: 'Address'
    },
    resumeType: 'Resume',
    enableAssessment: 'Assessment',
    assessmentType: 'Assessment Type',
    valuesAssessment: 'Value & Strengths Assessment',
    personalityAssessment: 'Personality Assessment',
    problemSolutionAssessment: 'Problem Solving Assessment',
    careerPreferenceAssessment: 'Career Interest Assessment',
    canReapplyDays: 'Allow Reapply(unit: day)',
    jobStatus: 'Job Status',
    applyUrl: 'Application Link',
    statusHistory: 'Job Status History',
    editable: 'Editable',
    notEditable: 'Not Editable',
    workTimeNotSpecified: 'Not Specified',
    candidateApplySatisfactionSurvey: 'Candidate Application Satisfaction Survey',
    candidateInterviewSatisfactionSurvey: 'Candidate Interview Satisfaction Survey',
    hmInterviewSatisfactionSurvey: 'HM Interview Satisfaction Survey',
    hmGradeSatisfactionSurvey: 'HM Rating Satisfaction Survey',
    channelAdditionalInfoTitle: 'Job Posting Additional Info',
    channelAdditionalInfo: {
      job_name: 'Job Name',
      industry: 'Industry'
    },
    jobSettings: {
      jobSettingTitle: 'Job Setting Logic',
      jobCloseSettingTitle: 'Job Close Email Notification',
      jobCancelSettingTitle: 'Job Cancel Email Notication',
      jobClosePrevContent: 'When the job is closed, send the',
      jobSettingsSendTo: 'to all candidates who did not reach',
      jobSettingsEnd: '',
      jobCancelPrevContent: 'When the job is cancelled, send the'
    },
    automationSettingsTitle: 'Automation Logic',
    companyPolicySettings: 'Policy Logic',
    revokeEmailAddress: 'Send email when candidate revoke application(s) to',
    revokeNoticeCandidateTitle: 'Notice to candidate - Candidate revoke an application or revoke his/her personal data',
    interviewSatisfactionTitle: 'Satisfaction Survey Logic',
    interviewSatisfactionSetting: 'Send interview satisfaction survey',
    resultStatusAutomation: {
      title: 'Candidate Status Logic',
      hmRatingEnabled: 'Candidate status update by rating result',
      interviewResultEnabled: 'Candidate status update by interview result'
    },
    ratingNotification: {
      title: 'Rating Completion Notifications',
      jobCreator: 'Job creator',
      teamMember: 'Team member',
      hmRating: {
        title: 'Resume Rating Completion Notification',
        organizer: 'Rating Inviter'
      },
      interviewRating: {
        title: 'Interview Rating Completion Notification',
        organizer: 'Interview Organizer'
      }
    },
    aiSettings: {
      title: 'AI Display Logic',
      candidateAiFitScoreForHmEnabled: 'Enable candidate AI fit score for interviewer'
    },
    birthdayReminderTitle: 'Birthday Notice Logic',
    birthdayReminderToCandidate: 'Send birthday notice to Candidates',
    birthdayReminderToEmployee: 'Send birthday notice to Employees',
    birthdayReminderToAlumni: 'Send birthday notice to Alumni',
    banner: 'Banner',
    backToJobList: 'Back to job list',
    prevJob: 'Previous Job',
    nextJob: 'Next Job',
    adpReferralRewardMessage: '200 Points',
    adpReferralTipMessage: 'According to ADP WeChat Referral Policy',
    experienceLabel: '{experience} year(s)',
    agreePolicyTitle: 'Please agree to the following policy',
    referralRewardTitle: 'Refer / Share',
    referralOrShareTip: "Click 'Share' to share the job link to your friends, or click 'Submit' to submit your friends resume directly.",
    experienceUnlimited: 'Not Specified',
    referralQrCodeTip: 'Send this QR code to your friend to apply! (If you would like to share via WeChat, please close this popup and click the WeChat icon to scan and then share)',
    referralRoleTitle: 'Referral',
    referralRoleTipContent: 'Are you an employee of {company}?',
    locationMap: 'Location',
    jobDescription: 'Job Description',
    shareToWeChat: 'Share To WeChat',
    jobDetailSalary: 'Salary',
    jobDetailRoleType: 'Role Type',
    jobDetailExperience: 'Experience',
    jobDetailWorkTime: 'Work Time',
    jobUpdateTime: 'Updated Time',
    shareToWeChatLogin: 'Scan the QR code via WeChat and share to your friend(s)! Please do NOT send this QR code directly to your friend(s).',
    changeStatusSettingsTitle: 'Candidate Status Logic',
    changeStatusSettingsTip: 'Status for non-consented candidate(s) cannot be updated to',
    loginSettingsTitle: 'Security',
    loginSettingsSessionAge: 'Login session duration',
    loginSettingsSessionAgeTip: 'hour(s)',
    loginSettingsEmployeeAutoWxLogin: 'Employee Account Auto-Login in WeChat',
    applicationReminderSettings: {
      title: 'Notification Logic',
      regarding: 'For candidate from',
      applicationWillNotBeSent: 'DO NOT SEND',
      continueToCompleteTheConsent: 'Consent',
      continueToCompleteTheApplication: 'Incomplete application reminder',
      via: ' ',
      email: 'Email',
      sms: 'SMS',
      weChat: 'WeChat',
      hrNoticeTitle: 'Notify job creator when there is an employee referral',
      jobMemberNoticeTitle: 'Notify team member(s) when there is an employee referral'
    },
    companyJobPoster: 'Company Poster(s)',
    ambassadorJobPoster: 'My Poster(s)',
    customJobPoster: 'Add new Poster',
    instructionsJobPoster: 'Instruction Poster(s)',
    viewMore: 'View More',
    shareTitle: 'Send to:',
    jobPosterTitle: 'Job Poster(s):',
    aiJobRequirementCriterionTipFirst: 'The AJINGA Intelligence Candidate Comparison table uses AI to help you compare candidates for screening and shortlisting. The purpose of this step is to identify the criteria you would like to use in the table.',
    aiJobRequirementCriterionTipSecond: 'Based on the job description, AJINGA Intelligence has suggested some criteria you may consider using. Click the criteria to add them to your list. You can also add new criteria and adjust the list order. Your selections will all be reflected in the comparison table. ',
    aiJobRequirementCriterionTipThird: 'You may come back and update your selections at any time.',
    selectAIJobRequirementCriterionTip: 'My Criteria',
    suggestionAIJobRequirementCriterionTip: 'AJINGA Intelligence Suggested Criteria',
    addAICriterionTip: 'Add a criteria',
    jobRequirementCriterionName: 'Criteria',
    confirmRefreshCriterionTitle: 'Refresh suggested criteria (if JD was updated)',
    confirmRefreshCriterionContent: 'Click refresh, if you have updated the job description, and would like the AI to suggest some new criteria.',
    emailIsDisabled: '{email} (Disabled)',
    hiddenPadding: 'Hide padding',
    selectJobInterviewRoom: 'Select AI Interview Room',
    testCandidate: 'Test',
    test: 'Test',
    candidateName: 'Name: ',
    testResultWithColon: 'Test Result: '
  },
  placeholder: {
    customContent: {
      title: 'Input title',
      videoCoverSize: 'Recommend size 640*480',
      videoSize: 'Suggest to upload 640*480 video, 1 min is preferred',
      imageSize: 'Recommend width size 1440px',
      imageOrVideoSize: 'Recommend image width 1440px. Only mp4 video up to {fileSize}MB is supported',
      pictureSize: 'Picture will be placed in one line. 300 x 300px recommended',
      imageDescription: 'Input description',
      imageLink: 'Input link',
      videoDescription: 'Input description',
      videoName: 'Video Name'
    },
    canReapplyDays: 'Empty Or 0 Means Not Allow Candidate Reapply',
    location: {
      city: 'please choice city',
      region: 'please choice district',
      cbd: 'please choice CBD',
      address: 'please input address '
    },
    filterCity: 'Select City',
    searchKeywords: 'Keyword Search',
    channelAdditionalInfo: {
      job_name: 'for resume parsing only',
      industry: 'Select industry(s)'
    }
  },
  btn: {
    selectQuestionnaire: 'Select Questionnaire',
    addTag: 'Add Tag',
    createLocation: 'Add Location(s)',
    selectLocation: 'Select Location(s)',
    addLocation: 'Add Location',
    confirmAddEmail: 'Confirm Email',
    jobStatus: {
      ACTIVE: 'Active',
      PENDING: 'On hold',
      CLOSED: 'Close',
      CANCEL: 'Cancel'
    },
    customContent: {
      addVideoCover: 'Add Cover Image',
      addVideo: 'Add Video',
      addImage: 'Add Image',
      addImageOrVideo: 'Add Image/Video',
      addPicture: 'Add a picture board',
      addCarouselContent: 'Add Slide Show Section',
      addVideContent: 'Add Video Section',
      addAvatar: 'Add Avatar Photo',
      addText: 'Add a \'text\' section',
      addPictureBoard: 'Add a \'picture board\' section'
    },
    postingChannel: {
      add: 'Publish',
      public: 'Open',
      hidden: 'Hide',
      update: 'Update',
      delete: 'Close',
      cancel: 'Cancel',
      syncIndustry: {
        yes: 'Update mapping logic',
        no: 'Save this job only'
      },
      autoPost: 'Auto Publish'
    },
    calibration: {
      HEIGHT: 'High',
      MIDDLE: 'Medium',
      LOW: 'Low'
    },
    saveAndBack: 'Save And Back',
    referralBtn: 'Refer',
    applyBtn: 'Apply',
    reapply: 'Reapply',
    applied: 'Applied',
    continueFinishApply: 'Continue',
    shareBtn: 'Share',
    submitBtn: 'Submit',
    yes: 'YES',
    no: 'NO',
    edit: 'Edit',
    delete: 'Delete',
    download: 'Download',
    editImgJobPoster: 'Upload image',
    editVideoJobPoster: 'Upload video',
    testCandidate: 'Test with this criteria'
  },
  message: {
    invalidEmail: 'please input a valid email',
    addNewEmailTip: {
      reminder: 'Enter your email address and every Monday, you will receive a weekly update of the total applicant number, for this position.',
      resume: 'When candidate finishes the job application, you will receive an email including application information and candidate resume.'
    },
    resumeTypeTip: {
      BASIC: {
        title: 'Only include name, mobile number, e-mail address'
      },
      MINI: {
        title: 'Mini Resume includes the following information of candidates:',
        contentList: ['Basic information', 'Contact information', 'Highest education', 'School', 'Working experience (include company name, position, starting and ending time)'],
        mark: 'This resume template is suitable for entry-level position or the position which does not require high education background for candidates.'
      },
      FULL: {
        title: 'Full Resume includes the following information of candidates:',
        contentList: ['Basic information', 'Full education experience', 'Work experiences', 'Reward acquired', 'Relevant skills', 'Additional information'],
        mark: 'This resume template is suitable for campus recruiting project or middle/senior management position.'
      }
    },
    requiredResumeAttachment: 'Resume Attachment Required',
    assessmentTip: {
      valuesAssessment: 'Measuring the candidate’s fit to your company culture.',
      personalityAssessment: ' Measuring the candidate’s personality fit to the job.',
      problemSolutionAssessment: ' Measuring the candidate’s mental ability.',
      careerPreferenceAssessment: 'Information on the candidate’s career and job preferences.'
    },
    openQuestionContainerTip: {
      PRESCREEN: ['Create a short set of screening questions for the Chatbot to ask candidates when they visit the Job Description page. Candidates\' responses help determine whether they meet your key requirements and guide suitable applicants toward submitting an application.'],
      NORMAL: [
        'This section allows you to define a short series of questions that all candidates must complete before submitting their application.',
        'There are five types of questions: an essay question for collecting open ended text feedback, a multiple-choice or single-choice question for collecting specific answers, a video application and an attachment question, and a date format question.'
      ],
      HR: [
        'This section allows you to define a short series of questions that can be updated directly by the recruiter when managing the candidate application.',
        'There are five types of questions: an essay question for collecting open ended text feedback, a multiple-choice or single-choice question for collecting specific answers, a video application and an attachment question, and a date format question.'
      ],
      INTERVIEW: [
        'This section allows you to define a short series of questions that can be updated directly by the recruiter when managing the candidate application.',
        'There are five types of questions: a rating question, a text question, a multiple-choice or single-choice question for collecting specific answers, and a date format question.'
      ],
      RATING: [
        'This section allows interviewers to evaluate and rate candidates based on their performance during the interview process.',
        'There are five types of questions: a rating question, a text question, a multiple-choice or single-choice question for collecting specific answers, and a date format question.'
      ]
    },
    notFoundPostingChannel: "Can't see your job board? Please contact your administrator or your AJINGA customer success consultant for support.",
    channelPostProcessing: 'Oops! The current task is still in progress. When this has been completed, you can submit your update.',
    copyApplyUrl: {
      success: 'Copy Success',
      fail: 'Copy failure. Please try to copy with "CTRL + C" again'
    },
    wrongFileType: 'invalid file type, please choice another',
    wrongFileSize: 'invalid file size, cannot larger than {size}MB, please choice another',
    emailIsExisted: 'cannot input same email',
    locationTip: [
      'Please choice city and input address',
      'Or click an position on the map, or drag and drop the pin to change the location.'
    ],
    locationIsExisted: 'Oops! Seems this location already exists, you don\'t need to add again.',
    personalityCalibrationDesc: [
      'The purpose of this step is to identify which employee characteristics will lead to success in the role. The outcome of this step will be an ideal job profile against which you can compare applicants and quickly identify those who best fit the job!',
      'To complete this step, provide a rating for each of the characteristics in terms of how important they are to the job. If you select only one rating, there are likely to be fewer matches. To widen your list of potential matches, you may select more than one level for each characteristic.',
      'If you are not sure about how to rate the characteristics, you may want to complete this step in collaboration with the hiring manager.'
    ],
    calibrationNeedAtLastOne: 'At least on importance needs to be selected',
    calibrationCannotOnlyHeightAndLow: 'Cannot only select "Height" and "Low" importance',
    refreshPageWithoutSaveData: 'Confirm to reload the page? The system does not save your changes.',
    requireCustomCarousel: 'You can add 1-7 images in this section.',
    requireCustomPicture: 'You can add 1-3 images in this section.',
    requireCustomVideo: 'Oops! Please upload your video.',
    requireCustomCarouselFile: 'Oops! It seems you may have forgotten to upload an image. Please check.',
    requireCustomVideoFile: 'Oops! Please upload your video.',
    requireCustomVideoCoverFile: 'Oops! Please add a \'cover\' image.',
    requireCustomText: 'Oops! Text is required.',
    updateJobPostingIndustryMapping: 'Oops, the industry selected is not aligned with the current mapping logic. Do you want to save this update and change the mapping logic or do you only want to update this specific job?',
    deleteJobSettingsSuccess: 'Successfully deleted!',
    cancelDeleteJobSettings: 'Cancelled deletion!',
    saveJobSettingsSuccess: 'Setting saved successfully.',
    saveJobSettingsMessage: 'Please add a setting logic and save.',
    requireDescription: 'This field is required.',
    requireAvatar: 'This field is required.',
    videoEndedTip: 'Scroll up to view  the next video.',
    agreementError: 'Please agree to the terms to continue.',
    deleteAmbassadorPosterSuccess: 'Successfully deleted!',
    deleteAmbassadorPosterFail: 'Error occurs, please try again.',
    requirementCriterionKeyHasExists: 'Key Has Exists',
    criterionMaxLimit: 'You may only select up to {num} criteria',
    resolveAddressError: 'Failed to query location based on address',
    pleaseConfirmToPostANewJob: 'Please confirm to post a new job.',
    jobFitConditionTip: [
      'AJINGA Intelligence intelligently extracts key requirements from the job description.',
      'Select the inputs that power your fit scoring.',
      'Refine anytime by adding or removing inputs.'
    ]
  },
  visibilityType: {
    IE: 'Internal & External',
    E: 'External Only',
    I: 'Internal Only'
  },
  experienceType: {
    experienced: 'Experienced',
    graduate: 'Fresh Graduate'
  },
  roleType: {
    FULL_TIME: 'Full Time',
    PART_TIME: 'Part Time',
    INTERNSHIP: 'Intern'
  },
  resumeType: {
    BASIC: 'Basic Registration',
    MINI: 'Mini Resume',
    FULL: 'Full Resume'
  },
  openQuestionContainerType: {
    PRESCREEN: 'Applicant Prescreen Questionnaire (Chatbot)',
    NORMAL: 'Applicant Questionnaire',
    HR: 'Recruiter Screening',
    INTERVIEW: 'Interview Questionnaire',
    RATING: 'Rating Questionnaire'
  },
  jobStatus: {
    CREATE: 'Created',
    ACTIVE: 'Activated',
    PENDING: 'On hold',
    REFRESH: 'Refresh',
    CLOSED: 'Closed',
    CANCEL: 'Cancelled'
  },
  assessmentType: {
    NORMAL: 'Normal',
    SIMPLE: 'Short'
  },
  personalityDescription: {
    COMPOSURE: {
      title: 'COMPOSURE',
      content: 'Rarely gets frustrated or annoyed. Very patient and can easily control their emotions.'
    },
    RESILIENCE: {
      title: 'RESILIENCE',
      content: 'Optimistic, self-confident, and manages stress well. Feels in control of their life and quickly gets over setbacks.'
    },
    TEAMWORK: {
      title: 'TEAMWORK',
      content: ' Sensitive to the needs of others and works well in team settings. Compassionate and loyal to friends and colleagues.'
    },
    OUTGOING: {
      title: 'OUTGOING',
      content: 'Sociable, talkative and tends to do well in social settings. Easily makes new friends and connections.'
    },
    LEADERSHIP: {
      title: 'LEADERSHIP',
      content: 'Likes to be in charge. Comfortable leading and directing others. Has clear opinions on what actions to take.'
    },
    MENTAL_AGILITY: {
      title: 'MENTAL AGILITY',
      content: 'Flexible thinker and keeps an open mind. Tends to see possibilities beyond obvious facts and likes to explore options in inventive ways. Willing to take risks when necessary.'
    },
    ORGANIZING: {
      title: 'ORGANIZING',
      content: 'Prefers to plan ahead and maintain clear structure in work and life. Likes following the rules and shows a high attention to detail.'
    },
    DRIVE: {
      title: 'DRIVE',
      content: 'Ambitious, energetic, and likes to win. Happiest when they are busy, and enjoys work environments with lots of activity.'
    },
    SERVICING: {
      title: 'SERVICING',
      content: 'Tends to be good at helping others and providing solutions and support. Has positive attitude towards service as a profession.'
    },
    SELLING: {
      title: 'SELLING',
      content: 'Tends to be good at convincing others of the value of a product, service, or idea. Has a positive attitude towards sales as a profession.'
    }
  },
  interviewSatisfactionSettingOption: {
    INTERVIEWED: 'when interview end',
    HN_RATED: 'when HM complete rating'
  },
  resourceLibrary: {
    requiredVideo: 'Please select a video'
  }
}
